import { API_URL, Status } from '../constants';
import { fetch } from '../fetchWrapper/fetch';

export const commitVenuesSync = async (eventId: string): Promise<void> => {
  const res = await fetch(`${API_URL}/venues/import/commit`, {
    method: 'POST',
    body: JSON.stringify({ event_id: eventId }),
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (!res.ok && res.status !== Status.ACCEPTED) {
    throw new Error(`Invalid status code returned: ${res.status}`);
  }
};
